<template>
    <p class="o-vacancies-listing__count" v-html="resultsCount"></p>
    <div class="o-vacancies-listing__results">
        <single-listing v-for="(job, job_key) in paginatedJobs" :key="job_key" :job="job"></single-listing>
    </div> 
    <div class="o-vacancies-listing__pagination" v-if="filteredJobs.length > perPage">
        <ul>
            <li v-for="(page, page_key) in totalPages" :key="page_key">
                <a :class="{ 'active' : page == currentPage }" @click="changePage( page )">{{ page }}</a>
            </li>
        </ul>
    </div>
</template>
<script>
    import SingleListing from './single-listing';

    import vacanciesMixin from "../../../mixins/vacancies";

    export default {
        name: 'VacanciesList',
        components: {
            SingleListing
        },
        mixins: [vacanciesMixin],
        computed: {
            paginatedJobs() {
                let vm = this;

                return vm.filteredJobs.slice( ( vm.currentPage -1 ) * vm.perPage, vm.currentPage * vm.perPage );
            },
            resultsCount() {
                let vm = this;

                if( vm.filteredJobs.length > 1 ) {
                    return vm.filteredJobs.length + ' ' + vm.$t("vacancies.results");
                } 

                return vm.filteredJobs.length + ' ' + vm.$t("vacancies.result");
            },
            totalPages() {
                let vm = this;

                return Math.ceil( vm.filteredJobs.length / vm.perPage );
            }
        },
        methods: {
            changePage( page ) {
                let vm = this;

                vm.currentPage = page;

                var results = document.getElementById("js-vacancies-listing");
                results.scrollIntoView();
            }
        },
        data() {
            return {
                currentPage: 1,
                perPage: 10
            }
        }
    }
</script>